import { ResetPasswordError } from '@pages/reset-password/models/reset-password-error.enum';

export const resetPasswordErrorMessages: Partial<Record<ResetPasswordError, string>> = {
  [ResetPasswordError.InvalidUserStatus]: 'reset-password.messages.invalid-user-status',
  [ResetPasswordError.PasswordSameAsLast]: 'reset-password.messages.password-same-as-last',
  [ResetPasswordError.PasswordMinimumRequiredLength]: 'reset-password.messages.password-minimum-required-length',
  [ResetPasswordError.UserNotFound]: 'reset-password.messages.user-not-found',
};

export const expiredResetPasswordErrors: ResetPasswordError[] = [
  ResetPasswordError.InvalidResetPasswordCode,
  ResetPasswordError.ResetPasswordCodeExpired,
];
